import React, { Component } from "react";
import "./App.css";
import { s360ConfigService } from "./Simplify360Chat/Services/S360Config";
import { fetchConfigDetailsFromClientHost } from "./Simplify360Chat/Services/HWIframeBridge";
import Simplify360Tatasky from "./Simplify360Tatasky/Simplify360Tatasky";

class App extends Component {
  constructor(props) {
    super(props);
    s360ConfigService.loadClientConfigFromToken();

    let configEncodedString = (window.location.pathname || "").substring(
      1,
      (window.location.pathname || "").length
    );

    const decodedString =
      s360ConfigService.decodeConfigToken(configEncodedString);

    this.state = {
      subscriberId:
        decodedString != null
          ? decodedString.subscriberId
          : s360ConfigService.getConfig.subscriberId,
      authenticated:
        decodedString != null
          ? decodedString.authenticated
          : s360ConfigService.getConfig.authenticated,
      viewType: s360ConfigService.getConfig.viewType,
      sessionId: s360ConfigService.config.sessionId,
      source: s360ConfigService.config.source,
      inputbox: s360ConfigService.config.inputbox,
      action: decodedString != null ? decodedString.action : null,
      src: decodedString != null ? decodedString.src : null,
      hideLoading: false,
      launchOnButton: decodedString != null ? decodedString.hideLoading : null,
      loginCount: 0,
      openChat: decodedString != null ? decodedString.openChat : null,
      userDetails: decodedString?.userDetails,
    };
  }

  componentDidMount() {
    fetchConfigDetailsFromClientHost();
  }

  render() {
    return (
      <div className="App">
        <Simplify360Tatasky
          subscriberId={this.state.subscriberId}
          inputbox={this.state.inputbox}
          authenticated={this.state.authenticated}
          viewType={this.state.viewType}
          sessionId={this.state.sessionId}
          source={this.state.source}
          action={this.state.action}
          hideLoading={this.state.hideLoading}
          launchOnButton={this.state.launchOnButton}
          loginCount={this.state.loginCount}
          openChat={this.state.openChat}
          src={this.state.src}
          userDetails={this?.state?.userDetails}
        />
      </div>
    );
  }
}

export default App;
